import { githubFetch } from './client';

export interface GitHubTreeGetParams {
  owner: string;
  repo: string;
  ref?: string;
  recursive?: boolean;
}

export interface GitHubTreeItem {
  path: string;
  mode: string;
  type: 'blob' | 'tree';
  sha: string;
  size?: number;
}

export interface GitHubTreeGetResponse {
  sha: string;
  tree: GitHubTreeItem[];
  truncated: boolean;
}

export async function githubTreeGet(
  params: GitHubTreeGetParams
): Promise<GitHubTreeGetResponse> {
  return githubFetch<GitHubTreeGetResponse>('/rpc/github_tree_get', {
    body: params,
  });
}
